export default __webpack_public_path__ + "static/media/exclaim.47516142.svg";